import axiosInstance from "@/api/axios-instance";

export async function getCouplesPack({
  page,
  search,
  filter,
  professional_id,
}: {
  page: number;
  search?: string;
  filter?: string;
  professional_id?: string;
}) {
  const response = await axiosInstance.get("/couples-packs", {
    params: { page, search, filter, professional_id },
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("couples packs is not loaded");
  }

  const { couplesPacks, nextPage, lastPage, page: currentPage } = response.data;
  return {
    couplesPacks,
    nextPage,
    lastPage,
    currentPage,
  };
}
